"use client";

import { HttpLink } from "@apollo/client";
import {
  ApolloNextAppProvider,
  ApolloClient,
  InMemoryCache,
} from "@apollo/experimental-nextjs-app-support";
import { getValueByStage } from "@/lib/appStage";

// GraphQL API endpoint
const graphqlUri = getValueByStage({
  prod: "https://api.rass.trackeros.co/super-gateway",
  dev: "https://dev.api.rass.londongrade.com/super-gateway",
  local: "https://dev.api.rass.londongrade.com/super-gateway",
});

// Create Apollo Client  
function makeClient() {
  const httpLink = new HttpLink({
    uri: graphqlUri,
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: httpLink,
  });

  return client;
}

// Simple Apollo wrapper for public pages
export function ApolloWrapper({ children }: React.PropsWithChildren) {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );
}

